"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.metricStringDateToUnixTime = exports.isIntervalInSprintCategory = exports.pullRequestDashboardStatuses = exports.DashboardExportFormat = exports.DashboardPRSizeToMergeTimeBucket = void 0;
const tslib_1 = require("tslib");
const database_types_1 = require("@acumen/database-types");
const moment_1 = tslib_1.__importDefault(require("moment"));
const dashboard_teams_report_1 = require("./dashboard-teams-report");
var DashboardPRSizeToMergeTimeBucket;
(function (DashboardPRSizeToMergeTimeBucket) {
    DashboardPRSizeToMergeTimeBucket["Fast"] = "FAST";
    DashboardPRSizeToMergeTimeBucket["Slow"] = "SLOW";
    DashboardPRSizeToMergeTimeBucket["Normal"] = "NORMAL";
})(DashboardPRSizeToMergeTimeBucket = exports.DashboardPRSizeToMergeTimeBucket || (exports.DashboardPRSizeToMergeTimeBucket = {}));
var DashboardExportFormat;
(function (DashboardExportFormat) {
    DashboardExportFormat["CSV"] = "CSV";
})(DashboardExportFormat = exports.DashboardExportFormat || (exports.DashboardExportFormat = {}));
exports.pullRequestDashboardStatuses = [
    {
        acumenStatuses: [database_types_1.AcumenPullRequestStatusWithWorkStart.Open, database_types_1.AcumenPullRequestStatusWithWorkStart.WorkStart],
        clientName: "Coding",
        metricKey: dashboard_teams_report_1.DashboardTeamReportMetric.PRCycleWorkInProgressHours,
    },
    {
        acumenStatuses: [database_types_1.AcumenPullRequestStatusWithWorkStart.AwaitingReview],
        clientName: "Waiting for review",
        metricKey: dashboard_teams_report_1.DashboardTeamReportMetric.PRCycleAwaitingReviewHours,
    },
    {
        acumenStatuses: [database_types_1.AcumenPullRequestStatusWithWorkStart.InReview],
        clientName: "In review",
        metricKey: dashboard_teams_report_1.DashboardTeamReportMetric.PRCycleInReviewHours,
    },
    {
        acumenStatuses: [database_types_1.AcumenPullRequestStatusWithWorkStart.Reviewed],
        clientName: "Pending merge",
        metricKey: dashboard_teams_report_1.DashboardTeamReportMetric.PRCycleReviewedHours,
    }
];
function isIntervalInSprintCategory(interval) {
    return (interval === database_types_1.MetricInterval.SPRINT || interval === database_types_1.MetricInterval.SPRINT_DATE);
}
exports.isIntervalInSprintCategory = isIntervalInSprintCategory;
function metricStringDateToUnixTime(key, timezone) {
    return moment_1.default.tz(key, "YYYY-MM-DD", timezone).toDate().getTime();
}
exports.metricStringDateToUnixTime = metricStringDateToUnixTime;
//# sourceMappingURL=dashboard-charts.js.map